export const ACTION_ID_LIVE_CHAT = 'StartChat'
export const ACTION_ID_EMAIL = 'EmailJustEat'
export const ACTION_ID_PHONE = 'PhoneJustEat'
export const ACTION_ID_PHONE_PARTNER = 'CallRestaurant'

export const ACTION_PRIMARY = 'Primary'
export const ACTION_SECONDARY = 'Secondary'

export const ACTION_TYPE_LIVE_CHAT = 'LiveChat'
export const ACTION_TYPE_EMAIL = 'Email'
export const ACTION_TYPE_CALL = 'Call'

export default {
  liveChat: {
    title: '',
    titleKey: 'action_chat_link_text',
    department: '',
    notes: null,
    tags: [],
    id: ACTION_ID_LIVE_CHAT,
    type: ACTION_TYPE_LIVE_CHAT,
    action: null,
    buttonEvent: {
      category: 'engagement',
      action: 'click_open_livechat',
      label: null,
      value: null
    }
  },
  email: {
    title: '',
    titleKey: 'action_email_link_text',
    department: '',
    tags: [],
    id: ACTION_ID_EMAIL,
    type: ACTION_TYPE_EMAIL,
    action: null,
    buttonEvent: {
      category: 'engagement',
      action: 'click_email_justeat',
      label: null,
      value: null
    }
  },
  phone: {
    title: '',
    titleKey: 'action_call_link_text',
    department: '',
    tags: [],
    id: ACTION_ID_PHONE,
    type: ACTION_TYPE_CALL,
    action: null,
    buttonEvent: {
      category: 'engagement',
      action: 'click_call_justeat',
      label: null,
      value: null
    }
  }
}
